var React = require('react');

function CloseInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M25 7 7 25M25 25 7 7","stroke":"#000","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

CloseInline.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","role":"img","focusable":"false"};

module.exports = CloseInline;

CloseInline.default = CloseInline;
